import React, { useState } from "react";
import { api } from "@/lib/api";
import { Card, CardContent } from "@/components/ui/card";
import { toast } from "sonner";

/** Visual style chips — fun edit presets applied during the film export. */
export default function StylePicker({ eventId, styles, value, onChanged }) {
  const [saving, setSaving] = useState("");

  const pick = async (styleId) => {
    if (styleId === value) return;
    setSaving(styleId);
    try {
      await api.patch(`/events/${eventId}`, { style: styleId });
      toast.success("Look updated");
      onChanged();
    } catch {
      toast.error("Could not update style");
    } finally {
      setSaving("");
    }
  };

  if (!styles?.length) return null;

  return (
    <Card className="bg-white border-[var(--em-line)]">
      <CardContent className="p-6">
        <p className="font-mono-label text-[var(--em-clay)]">Fun edits</p>
        <h3 className="font-serif-em text-xl mt-3">Pick a look</h3>
        <p className="text-sm text-[var(--em-ink-soft)] mt-1">Color grade, film grain and gentle fades applied to every clip.</p>
        <div className="mt-4 grid grid-cols-1 gap-2">
          {styles.map((s) => {
            const active = (value || "classic") === s.id;
            return (
              <button
                key={s.id}
                data-testid={`style-chip-${s.id}`}
                onClick={() => pick(s.id)}
                disabled={!!saving}
                className={`text-left rounded-xl border px-4 py-3 transition-colors ${
                  active
                    ? "border-[var(--em-clay)] bg-[var(--em-clay)]/10"
                    : "border-[var(--em-line)] bg-[var(--em-bg)] hover:border-[var(--em-clay)]/50"
                }`}
              >
                <div className="flex items-center justify-between">
                  <span className={`text-sm font-medium ${active ? "text-[var(--em-clay)]" : ""}`}>{s.label}</span>
                  {active && <span className="text-[10px] font-semibold uppercase tracking-wide text-[var(--em-clay)]">Selected</span>}
                  {saving === s.id && <span className="text-[10px] text-[var(--em-ink-soft)]">Saving…</span>}
                </div>
                <p className="text-xs text-[var(--em-ink-soft)] mt-0.5">{s.description}</p>
              </button>
            );
          })}
        </div>
      </CardContent>
    </Card>
  );
}
